import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  checkUpdateAppoinmentStatus,
  updateAppoinment,
  cancelAllPatientAppoinment,
} from "../../../api/apiHandler";
import Header from "../../../components/header/Header";
import Footer from "../../../components/footer/Footer";
import Select from "react-select";

import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import queryString from "query-string";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import moment from "moment-timezone";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { EmailMeetingRecordsPopup } from "../../../modal/emailMeetingRecordsPopup";

function MeetingStatus() {
  const navigate = useNavigate();
  const [doctorMeetingStatusList, setDoctorMeetingStatusList] = useState([]);
  const [totalRecordCount, setTotalRecordCount] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [userTimezone, setUserTimezone] = useState("");
  const [refresh, setRefresh] = useState(false);
  const location2 = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [meetingId, setMeetingId] = useState("");
  console.log("location22ddeeee", location2.state);
  const params = queryString.parse(window.location.search);
  const doctorSpecialities = [
    { value: 0, label: "All" },
    //{ value: 1, label: "PENDING" },
    { value: 2, label: "ACCEPTED" },
    // { value: 3, label: "REJECTED" },
    { value: 4, label: "ONGOING" },
    { value: 5, label: "DONE" },
    { value: 6, label: "CANCELLED" },
  ];
  // useEffect(() => {
  //   console.log("Route changed to:", params);
  //   // You can fetch data or update state here
  // }, [params]);
  const [selectedStatus, setSelectedStatus] = useState(doctorSpecialities[0]);

  useEffect(() => {
    // const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timezone = moment.tz.guess();
    setUserTimezone(timezone);
    if (searchQuery == "") {
      Swal.fire({
        title: "Please wait...",
        didOpen: () => {
          Swal.showLoading();
        },
      });
    }
    checkUpdateAppoinmentStatus({
      page: pageNo,
      record_count: perPage,
      search_text: searchQuery,
      appointmentStatus: selectedStatus.value,
      isPriestMeeting: params?.isPriestMeeting == "true" ? 1 : 0,
    }).then((response) => {
      Swal.close();
      response = JSON.parse(response);
      console.log("response1111111111111111", response);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        setDoctorMeetingStatusList(response.data.patient_data);
        setTotalRecordCount(
          Math.ceil(response.data.total_record_count / perPage)
        );
      } else {
        setDoctorMeetingStatusList([]);
        setTotalRecordCount(1);
      }
      setRefresh(false);
    });

    // Swal.close();
  }, [searchQuery, pageNo, refresh, selectedStatus, params?.isPriestMeeting]);

  const handlePageClick = (event) => {
    setPageNo(event.selected + 1);
  };

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
  };

  const handleJoinMeeting = (patient_data) => {
    console.log("patient_data", patient_data);
    const joinMeetingObj = {
      meeting_id: patient_data.meeting_information[0].meeting_id,
      appointment_id: patient_data.id,
      // "user_id": patient_data.doctor_information.id,
      // "name": patient_data.doctor_information.doctor_full_name,
      // "email": patient_data.doctor_information.doctor_email,
      user_id: localStorage.getItem("user_id"),
      name: localStorage.getItem("user_name"),
      email: localStorage.getItem("user_email"),
      role: parseInt(localStorage.getItem("user_login_type_role")),
      start_meeting: 0,
    };
    console.log("joinMeetingObj", joinMeetingObj);
    navigate("/meeting", { state: joinMeetingObj });
  };

  // const handleStartMeeting = (patient_data) => {
  //   // to={`/meeting/${item.id}`}
  // }

  const handlePatientMeetingStatus = (id) => {
    console.log("handleLeave");
    const updateStatusObj = {
      appointment_id: id,
    };

    updateAppoinment(updateStatusObj).then(async (response) => {
      response = JSON.parse(response);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        SpeechRecognition.stopListening();
        setRefresh(true);
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    });
  };
  const endAllMeetings = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will cancel all ongoing meeting!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        // Proceed with canceling all appointments if confirmed
        cancelAllPatientAppoinment({})
          .then(async (response) => {
            response = JSON.parse(response);
            if (response.code == process.env.REACT_APP_SUCCESS) {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: response.message,
                toast: true,
                showConfirmButton: false,
                timer: 2000,
              }).then(() => {
                setRefresh(true);
              });
            } else {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: response.message,
                toast: true,
                showConfirmButton: false,
                timer: 2000,
              });
            }
          })
          .catch((error) => {
            // Handle any errors that may occur in the promise chain
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: "An error occurred. Please try again.",
              toast: true,
              showConfirmButton: false,
              timer: 2000,
            });
            console.error("Error cancelling meeting:", error);
          });
      }
      // No need to show "Action canceled" toast anymore
    });
  };
  const isOpenMailModal = (meetingId) => {
    if (!meetingId) {
      return Swal.fire({
        icon: "error",
        title: "Invalid Meeting",
        text: "Meeting ID is not find.",
      });
    }
    setIsOpen(true);
    setMeetingId(meetingId);
  };
  let userRole = localStorage.getItem("user_login_type_role");
  // const handleMeetiRecord = async (id) => {
  //   try {
  //     if (userRole == "4") {
  //       navigate(`/priest/meeting-record/${id}`);
  //     } else if(){
  //       navigate(`/doctor/meeting-record/${id}`);
  //     }
  //   } catch (error) {}
  // };
  const handleMeetiRecord = async (id) => {
    console.log(id, "id2xr60lyh");
    if (!id) {
      return Swal.fire({
        icon: "error",
        title: "Invalid Meeting",
        text: "Meeting ID is not find.",
      });
    }

    try {
      if (userRole === "4") {
        // Priest
        navigate(`/priest/meeting-record/${id}`);
      } else if (userRole === "1" || params?.isPriestMeeting === "true") {
        // Patient with priest meeting
        const priestQuery = `isPriestMeeting=${
          params?.isPriestMeeting === "true"
        }`;
        navigate(`/patient/meeting-record/${id}?${priestQuery}`);
      } else {
        // Doctor
        navigate(`/doctor/meeting-record/${id}`);
      }
    } catch (error) {
      console.error("Navigation error:", error);
    }
  };

  const handleAutoRx = async () => {
    try {
      if (userRole == "4") {
        navigate("/priest/carepoint/1");
      } else if (params?.isPriestMeeting == "false" && userRole == "1") {
        navigate("/patient/carepoint/1");
      } else {
        navigate("/doctor/carepoint/1");
      }
    } catch (error) {}
  };
  return (
    <>
      <Header />
      <EmailMeetingRecordsPopup
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        meetingId={meetingId}
        setMeetingId={setMeetingId}
      />
      <section className="doctorsec-pad">
        <div className="container">
          <div className="mt-4">
            <p className="font_22 font_600 mb-0">Meeting Status </p>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/doctor/home" className="font_14">
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active font_14"
                  aria-current="page"
                >
                  Meeting Status
                </li>
              </ol>
            </nav>
          </div>
          <div className="card">
            <div className="card-body doctor-table-card">
              <div
                className="row justify-content-between align-items-end position-relative"
                style={{ zIndex: 99 }}
              >
                <div className="col-md-3 my-1">
                  <label
                    htmlFor="statusFilter"
                    className="white-space-nw"
                    style={{ marginRight: "8px", fontSize: "14px" }}
                  >
                    Filter by Status:
                  </label>
                  <div className="d-flex align-items-center gap-10 w-100">
                    <div className="w-100" style={{ maxWidth: 200 }}>
                      <Select
                        placeholder="Filter by Status"
                        className="react-select__menu"
                        classNamePrefix="select"
                        name="selectedStatus"
                        options={doctorSpecialities}
                        value={selectedStatus}
                        onChange={(selectedOption) => {
                          setSelectedStatus(selectedOption);
                          setPageNo(1);
                          setSearchQuery("");
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="search-bar col-lg-3 col-md-3">
                  <label
                    htmlFor="statusFilter"
                    className="white-space-nw"
                    style={{ marginRight: "8px", fontSize: "14px" }}
                  >
                    Search by:
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Name or Email"
                    value={searchQuery}
                    onChange={handleSearch}
                  />
                </div>
                <div className="col-lg-3">
                  <button
                    className="meeting-status status-reject font_600 w-100"
                    style={{ maxWidth: "100%" }}
                    onClick={endAllMeetings}
                  >
                    End All Meetings
                  </button>
                </div>
                <div className="search-bar"></div>
              </div>
              <div className="table-responsive">
                <table
                  id="mangeUser"
                  className="table table-hover dataTable js-exportable"
                >
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th> Name</th>
                      <th>Phone Number</th>
                      <th>Email Address</th>
                      <th>Date Time</th>
                      <th>Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {doctorMeetingStatusList &&
                      doctorMeetingStatusList.map((item, index) => {
                        return (
                          <tr id={item.id} key={index}>
                            <td>{item.id}</td>

                            <td>
                              <h3 className="doc-details">
                                <div className="doc-profile">
                                  <img
                                    src={item.doctor_information.profile_image}
                                    alt=""
                                  />
                                </div>
                                {item.doctor_information.doctor_full_name}
                              </h3>
                            </td>
                            <td>
                              {item.doctor_information.country_code +
                                " " +
                                item.doctor_information.doctor_phone_no}
                            </td>
                            <td>{item.doctor_information.doctor_email}</td>
                            <td>
                              {/* {moment.utc(item.appointment_date + " " + item.appointment_time).tz(userTimezone).format('DD/MM/YYYY hh:mm A')} */}
                              {moment
                                .tz(
                                  `${item.appointment_date} ${item.appointment_time}`,
                                  "YYYY-MM-DD hh:mm A",
                                  "UTC"
                                )
                                .tz(userTimezone)
                                .format("DD/MM/YYYY hh:mm A")}
                            </td>
                            <td>
                              <div className="d-flex gap-2">
                                <button>
                                  {item.appointment_status === 1 ? (
                                    <p className="meeting-status status-pending font_600 ">
                                      Pending
                                    </p>
                                  ) : item.appointment_status === 2 ? (
                                    <p className="meeting-status status-accept font_600 ">
                                      Accepted
                                    </p>
                                  ) : item.appointment_status === 3 ? (
                                    <p className="meeting-status status-reject font_600 ">
                                      Reject
                                    </p>
                                  ) : item.appointment_status === 4 ? (
                                    <p className="meeting-status status-ongoing font_600 ">
                                      Ongoing
                                    </p>
                                  ) : item.appointment_status === 5 ? (
                                    <p className="meeting-status status-accept font_600 ">
                                      Done
                                    </p>
                                  ) : (
                                    <p className="meeting-status status-reject font_600 ">
                                      Cancelled
                                    </p>
                                  )}
                                </button>
                                {item.appointment_status === 4 ? (
                                  <button
                                    className="meeting-status status-ongoing font_16"
                                    onClick={() => handleJoinMeeting(item)}
                                  >
                                    Join
                                  </button>
                                ) : (
                                  ""
                                )}
                                {item.appointment_status === 4 && (
                                  <button
                                    className="meeting-status status-reject font_600"
                                    onClick={() =>
                                      handlePatientMeetingStatus(item.id)
                                    }
                                  >
                                    End
                                  </button>
                                )}
                                {params?.isPriestMeeting == "false" &&
                                  userRole == "1" && (
                                    <button
                                      className="commonBtn btn-sm px-2"
                                      onClick={() => handleAutoRx()}
                                    >
                                      {" "}
                                      AutoRx
                                    </button>
                                  )}
                                <button
                                  className="commonBtn btn-sm px-2"
                                  onClick={() =>
                                    handleMeetiRecord(
                                      item?.meeting_information[0]?.meeting_id
                                    )
                                  }
                                >
                                  {" "}
                                  Meeting Record
                                </button>
                                <button
                                  className="commonBtn btn-sm px-2"
                                  onClick={() =>
                                    isOpenMailModal(
                                      item?.meeting_information[0]?.meeting_id
                                    )
                                  }
                                >
                                  {" "}
                                  Mail Record
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
                <ReactPaginate
                  breakLabel="..."
                  nextLabel=" > "
                  onPageChange={handlePageClick}
                  pageCount={totalRecordCount}
                  previousLabel=" < "
                  renderOnZeroPageCount={null}
                  containerClassName="pagination"
                  pageLinkClassName="page-link"
                  previousLinkClassName="page-link"
                  nextLinkClassName="page-link"
                  disabledClassName="disabled"
                  activeClassName="active"
                  activeLinkClassName="active-link"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default MeetingStatus;
